(function ($) {
  toutProductV1 = {
    formatter: $('.tout-product-v1')
  };

  Drupal.behaviors.toutProductV1 = {
    get: function (key) {
      return toutProductV1[key];
    },

    set: function (key, val) {
      toutProductV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var prodId = thisFormatter.find('.product-tout .product').attr('data-productid');

        thisFormatter.find('.product-tout .product .product-image').addClass(prodId);
      });
    }
  };
})(jQuery);
